<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="!bodyList" class="modal-body">
    <p *ngIf="!isFormattedText">{{ body }}</p>
    <pre *ngIf="isFormattedText">{{ body }}</pre>
  </div>
  <div *ngIf="bodyList && bodyList.length > 0" class="modal-body" style="overflow-y: scroll; max-height: 237px">
    <p *ngFor="let message of bodyList">{{ message }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary"
      data-dismiss="modal"
      (click)="ok()"
    >
      {{ buttonText }}
    </button>
  </div>
</div>
